import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule } from '@ngx-translate/core';
// import { MatButtonModule, MatCheckboxModule, MatIconModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { TempproHistoryService } from './temp_pro_history.service';
import { TempproHistoryComponent } from './temp_pro_history.component';
import {HttpClientModule} from '@angular/common/http';
import {HttpModule} from '@angular/http';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatSelectModule, MatCheckboxModule, MatIconModule, MatInputModule, MatSlideToggleModule, MatToolbarModule } from '@angular/material';
import { FuseConfirmDialogModule } from '@fuse/components';
// import {Anadirpagocomponent2Component} from '../anadirpagocomponent2/anadirpagocomponent2.component'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
const routes = [
    {
        path     : 'temp_pro_history',
        component: TempproHistoryComponent
    }
];

@NgModule({
    declarations: [
        TempproHistoryComponent,
       
      //  Anadirpagocomponent2Component
    ],
    imports     : [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatCheckboxModule,
        SweetAlert2Module,
        MatIconModule,
        TranslateModule,
        AgGridModule.withComponents([]),
        FuseSharedModule,
        HttpClientModule, HttpModule,
        FuseConfirmDialogModule,
        MatDatepickerModule,
        
        NgxMatSelectSearchModule,
        MatSelectModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule
    
    ],
    exports     : [
        TempproHistoryComponent
    ],
    providers: [TempproHistoryService],
    entryComponents: [],

 
})

export class TempproHistoryModule
{
}
